/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_ConfigurationInputs */

const en_nav_section_configuration = /** @type {(inputs: Nav_Section_ConfigurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration`)
};

/**
* | output |
* | --- |
* | "Configuration" |
*
* @param {Nav_Section_ConfigurationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_configuration = /** @type {((inputs?: Nav_Section_ConfigurationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_ConfigurationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_section_configuration(inputs)
});